import React from 'react';
import NavigationContainer from './navigations/NavigationContainer';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {ThemeProvider} from './contexts/ThemeContext';
import {GOOGLE_IDS} from 'constants/googleAuthId';
import {RootStoreProvider} from 'contexts/StoreContext';
import NavigationPopUp from 'components/organisms/notificationPopUp';
import Loader from 'components/organisms/loader';

const App = () => {
  return (
    <ThemeProvider>
      <GoogleOAuthProvider clientId={GOOGLE_IDS.webClientId}>
        <RootStoreProvider>
          <NavigationContainer />
          <NavigationPopUp />
          <Loader />
        </RootStoreProvider>
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
};

export default App;
